import PropTypes from 'prop-types'
import React from 'react'

const ScrollingBanner = ({ background, text, iconColor, length }) => {
  const classes = background
    ? `scrolling-banner ${background}`
    : 'scrolling-banner'

  const iconClass = iconColor ? `sun-icon ${iconColor}` : 'sun-icon'

  return (
    <div className={classes}>
      <div className='scroll__text'>
        <p>
          {Array.from({ length }, (_, index) => (
            <span key={index.toString()}>
              <span className={iconClass}>&#10042;</span>
              {text}
            </span>
          ))}
        </p>
        <p>
          {Array.from({ length }, (_, index) => (
            <span key={index.toString()}>
              <span className={iconClass}>&#10042;</span>
              {text}
            </span>
          ))}
        </p>
      </div>
    </div>
  )
}

ScrollingBanner.defaultProps = {
  background: '',
  iconColor: ''
}

ScrollingBanner.propTypes = {
  background: PropTypes.string,
  text: PropTypes.string,
  iconColor: PropTypes.string,
  length: PropTypes.number
}

export default ScrollingBanner



// WEBPACK FOOTER //
// ./src/components/scrolling-banner.js